/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusCreateUnteraufgabeDto } from '../../models/lexplus-create-unteraufgabe-dto';
import { LexplusSuccessDto } from '../../models/lexplus-success-dto';

export interface AufgabenControllerCreateUnteraufgabeV1$Params {
  id: number;
      body: LexplusCreateUnteraufgabeDto
}

export function aufgabenControllerCreateUnteraufgabeV1(http: HttpClient, rootUrl: string, params: AufgabenControllerCreateUnteraufgabeV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusSuccessDto>> {
  const rb = new RequestBuilder(rootUrl, aufgabenControllerCreateUnteraufgabeV1.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusSuccessDto>;
    })
  );
}

aufgabenControllerCreateUnteraufgabeV1.PATH = '/v1/aufgaben/{id}/unteraufgaben';
